import { TFunction } from 'i18next';

export const apiKeyTypeLabelMapper = (type: string, t: TFunction): string => {
  switch (type) {
    case 'analytics':
      return t('developer_tools.api_form.type.analytics');
    case 'manage':
      return t('developer_tools.api_form.type.manage');
    case 'use':
      return t('developer_tools.api_form.type.use');
    default:
      return type;
  }
};
